import ReactDOM from 'react-dom';
import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import FetchBackend from 'i18next-fetch-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import LanguageDetector from 'i18next-browser-languagedetector';
import { useTranslation, initReactI18next } from 'react-i18next';

import { isUndefined, isNull } from 'lodash';
import { getBlob } from '../api';

const localLanguage = !isUndefined(localStorage.getItem('i18nextLng')) ?
  !isNull(localStorage.getItem('i18nextLng')) ?
    localStorage.getItem('i18nextLng')
    : 'zh'
  : 'zh';

export default i18n;
